import { confirmActionWithSuspiciousItems } from 'Cloud/Application/Suspicious';
import Emitter from 'Emitter';
import { clone } from 'ramda';
import { getAttachFolders, toggleFolder } from 'reactApp/modules/attaches/attaches.actions';
import { downloadAttachesByIds, downloadAttachItem, forwardItems } from 'reactApp/modules/attaches/attaches.helpers';
import { AttachesSelectors } from 'reactApp/modules/attaches/attaches.selectors';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { settingsController } from 'reactApp/modules/settings/settings.controller';
import { getParams } from 'reactApp/sections/AttachesPage/helpers';
import { store } from 'reactApp/store';
import { sendGa } from 'reactApp/utils/ga';

class AttachesController extends Emitter {
    static sendGa = (action, label, iData) => {
        const viewMode = settingsController.getViewMode();
        sendGa(`attaches-${viewMode}`, action, label, iData);
    };

    getTotalCount = () => AttachesSelectors.getAttachesList(store.getState()).length;

    downloadSelectedAttaches = () => {
        const ids = SelectionsSelectors.getSelectedIdxs(store.getState());

        if (!ids || !ids.length) {
            return;
        }

        const items = ids.map((id) => AttachesSelectors.getAttachById(store.getState(), id));

        this.downloadAttaches(items);
    };

    downloadAttaches = (items) => {
        if (!items || !items.length) {
            return;
        }

        AttachesController.sendGa('download-from-toolbar', items.length);

        items.forEach((item) => AttachesController.sendGa('download', item.ext));

        if (items.length === 1) {
            downloadAttachItem(items[0]);
        } else {
            AttachesController.sendGa('download-multiple');
            confirmActionWithSuspiciousItems(clone(items), 'download').then(function () {
                downloadAttachesByIds(items.map((item) => item.id));
            });
        }
    };

    forwardSelectedAttaches = () => {
        const ids = SelectionsSelectors.getSelectedIdxs(store.getState());
        const state = store.getState();
        const items = ids.map((id) => AttachesSelectors.getAttachById(state, id));

        items.forEach((item) => AttachesController.sendGa('forward', item.ext));

        if (items && items.length > 1) {
            AttachesController.sendGa('forward-multiple');
        }

        forwardItems(ids);
    };

    getParams = getParams;

    getFolders = () => {
        const folders = Array.from(Object.values(AttachesSelectors.getAttachFolders(store.getState())));

        if (!folders || folders.length <= 0) {
            return new Promise((resolve, reject) =>
                store
                    .dispatch(getAttachFolders())
                    .then(() => resolve(Array.from(Object.values(AttachesSelectors.getAttachFolders(store.getState())))))
                    .catch((error) => reject(error))
            );
        }

        return Promise.resolve(folders);
    };

    getFolderById = (id) => AttachesSelectors.getAttachFolderById(store.getState(), id);

    getAttachFoldersTree = (activeFolderId) =>
        this.getFolders().then((mailFolders) => AttachesSelectors.getAttachesFoldersTree(store.getState(), activeFolderId));

    toggleFolder = (id) => store.dispatch(toggleFolder({ id }));

    getAttachById = (id) => {
        return AttachesSelectors.getAttachById(store.getState(), id);
    };

    getUserFolders = () =>
        this.getFolders().then((folders) => folders.filter((folder) => !folder.system));

    getMessagesTotalCount = () =>
        this.getFolders().then(() => AttachesSelectors.getAllMessagesTotalCount(store.getState()));
}

const attachesController = new AttachesController();

export { attachesController, AttachesController };
